import { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { logout } from "../../auth-client/slice/clientAuth";
import { useDispatch } from "react-redux";
import { googleLogout } from '@react-oauth/google';
import { useSelector } from "react-redux";
import { getClientInfo } from "../slice/clientPanelInfoSlice";

const ClientSidebar = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isVerified = useSelector((state) => state.clientInfo.isClientVerified);
  const clientInfo  = useSelector((state) => state.clientInfo.clientsInfo);
  // console.log("isVerified", isVerified);
  // console.log("clientInfo ", clientInfo );
  const token = localStorage.getItem("client_access_token");

  useEffect(() => {
    if (!clientInfo && token) {
      dispatch(getClientInfo(token));
    }
  }, [clientInfo, dispatch, token]);

  const verifiedLinks = [
    // { to: "info", label: "My Info" },
    // { to: "verify", label: "Verify" },
    { to: "documents", label: "My Documents" },
    { to: "issue", label: "Child Issues" },
    { to: "self_assessment", label: "Self Assessment" },
    { to: "book_appointment", label: "My Appointments" },
    { to: "list_payment", label: "My Subscriptions" },
    { to: "claim", label: "Claim" },
    { to: "/client/chat/provider", label: "Chat" },
  ];

  const baseLinks = [
    { to: "info", label: "My Info" },
  ];

  if (!isVerified) {
    baseLinks.push({ to: "verify", label: "Verify" });
  }

  const links = [...baseLinks, ...(isVerified ? verifiedLinks : [])];

  const handleClientLogout = () => {
    googleLogout();
      dispatch(logout());
      navigate("/");
    };

  return (
    // <div className="bg-light p-3" style={{ width: "200px", minHeight: "100vh" }}>
    //   <ul className="nav flex-column">
    //     <li className="nav-item">
    //       <NavLink
    //         to="info"
    //         className={({ isActive }) => `nav-link ${isActive ? "active fw-bold text-primary" : ""}`}
    //       >
    //         Client Info
    //       </NavLink>
    //     </li>
    //     <li className="nav-item">
    //       <NavLink
    //         to="documents"
    //         className={({ isActive }) => `nav-link ${isActive ? "active fw-bold text-primary" : ""}`}
    //       >
    //         Documents
    //       </NavLink>
    //     </li>
    //     <li className="nav-item">
    //       <NavLink
    //         to="issue"
    //         className={({ isActive }) => `nav-link ${isActive ? "active fw-bold text-primary" : ""}`}
    //       >
    //         Child issue
    //       </NavLink>
    //     </li>
    //     <li className="nav-item">
    //       <NavLink
    //         to="self_assessment"
    //         className={({ isActive }) => `nav-link ${isActive ? "active fw-bold text-primary" : ""}`}
    //       >
    //         Self Assessment
    //       </NavLink>
    //     </li>
    //     <li className="nav-item">
    //       <NavLink
    //         to="book_appointment"
    //         className={({ isActive }) => `nav-link ${isActive ? "active fw-bold text-primary" : ""}`}
    //       >
    //         Book Appointment
    //       </NavLink>
    //     </li>
    //   </ul>
    // </div>
    <>
      <div className="col-md-4 col-xl-3 sidebar">
        <h4 className="font-weight-bold montserrat text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 d-flex align-items-center">
          Client
          {isVerified && (
            <>
              <svg width="60" height="55" viewBox="0 0 401 401" fill="none" xmlns="http://www.w3.org/2000/svg" className="ms-auto">
                <path d="M133.784 39.8494C109.913 46.4237 86.205 53.577 62.6814 61.3029C60.5318 61.9961 58.6208 63.2805 57.167 65.0091C55.7132 66.7377 54.7754 68.8406 54.4609 71.0772C40.5763 175.262 72.6563 251.277 110.927 301.352C127.123 322.771 146.444 341.636 168.245 357.316C176.916 363.431 184.585 367.842 190.626 370.674C193.633 372.095 196.081 373.08 197.969 373.632C198.801 373.884 199.646 374.094 200.5 374.258C201.346 374.093 202.182 373.884 203.006 373.632C204.911 373.064 207.367 372.078 210.375 370.674C216.39 367.842 224.084 363.406 232.756 357.316C254.556 341.636 273.877 322.771 290.074 301.352C328.344 251.302 360.424 175.262 346.539 71.0772C346.225 68.8406 345.287 66.7377 343.833 65.0091C342.38 63.2805 340.468 61.9961 338.319 61.3029C322.003 55.9646 294.459 47.2679 267.217 39.8744C239.397 32.3306 213.808 26.7417 200.5 26.7417C187.217 26.7417 161.603 32.3056 133.784 39.8494ZM127.117 14.035C154.31 6.64156 183.207 0 200.5 0C217.793 0 246.69 6.64156 273.883 14.035C301.703 21.5538 329.747 30.4509 346.239 35.8394C353.133 38.1163 359.246 42.2921 363.875 47.8869C368.503 53.4818 371.459 60.2688 372.404 67.4682C387.341 179.673 352.68 262.83 310.625 317.843C292.784 341.37 271.521 362.092 247.542 379.321C239.26 385.297 230.471 390.538 221.277 394.985C214.259 398.293 206.716 401 200.5 401C194.285 401 186.766 398.293 179.723 394.985C170.529 390.538 161.74 385.297 153.458 379.321C129.479 362.092 108.216 341.37 90.3755 317.843C48.3206 262.83 13.6592 179.673 28.5964 67.4682C29.541 60.2688 32.4973 53.4818 37.1256 47.8869C41.754 42.2921 47.8668 38.1163 54.7617 35.8394C78.7028 27.995 102.828 20.7248 127.117 14.035Z" fill="#002B45"/>
                <path d="M272.2 204.682C273.367 205.846 274.293 207.228 274.925 208.751C275.557 210.273 275.882 211.905 275.882 213.554C275.882 215.202 275.557 216.834 274.925 218.356C274.293 219.879 273.367 221.262 272.2 222.426L197.013 297.613C195.849 298.78 194.466 299.706 192.944 300.338C191.421 300.97 189.789 301.295 188.141 301.295C186.493 301.295 184.86 300.97 183.338 300.338C181.816 299.706 180.433 298.78 179.269 297.613L141.675 260.02C140.51 258.854 139.586 257.471 138.955 255.949C138.325 254.427 138 252.795 138 251.147C138 249.5 138.325 247.868 138.955 246.346C139.586 244.824 140.51 243.44 141.675 242.275C142.84 241.11 144.223 240.186 145.746 239.555C147.268 238.925 148.899 238.6 150.547 238.6C152.195 238.6 153.826 238.925 155.349 239.555C156.871 240.186 158.254 241.11 159.419 242.275L188.141 271.022L254.456 204.682C255.62 203.515 257.003 202.589 258.526 201.957C260.048 201.325 261.68 201 263.328 201C264.977 201 266.609 201.325 268.131 201.957C269.654 202.589 271.036 203.515 272.2 204.682Z" fill="#002B45"/>
                <path d="M81.2614 125.364L85.0966 156.131H85.4375L99.5 125.364H112.881L91.233 169H75.0398L67.8807 125.364H81.2614ZM109.839 169L117.083 125.364H148.532L146.913 134.909H127.311L126.118 142.409H144.1L142.481 151.955H124.498L123.305 159.455H142.822L141.203 169H109.839ZM147.163 169L154.408 125.364H173.243C176.482 125.364 179.216 125.953 181.446 127.132C183.676 128.311 185.281 130.009 186.261 132.224C187.241 134.44 187.476 137.097 186.964 140.193C186.453 143.318 185.324 145.953 183.577 148.098C181.844 150.229 179.635 151.848 176.95 152.956C174.28 154.05 171.283 154.597 167.959 154.597H156.709L158.243 145.392H167.107C168.499 145.392 169.72 145.222 170.771 144.881C171.822 144.526 172.675 143.972 173.328 143.219C173.982 142.452 174.408 141.443 174.607 140.193C174.805 138.943 174.706 137.928 174.308 137.146C173.911 136.351 173.25 135.768 172.327 135.399C171.403 135.016 170.26 134.824 168.896 134.824H164.72L159.01 169H147.163ZM176.055 148.972L183.641 169H170.771L163.442 148.972H176.055ZM206.918 125.364L199.674 169H187.827L195.072 125.364L206.918 125.364ZM205.288 169L212.533 125.364H243.214L241.595 134.909H222.76L221.567 142.409H238.527L236.908 151.955H219.947L217.135 169H205.288ZM259.418 125.364L252.174 169H240.327L247.572 125.364H259.418ZM257.788 169L265.033 125.364H296.482L294.862 134.909H275.26L274.067 142.409H292.05L290.43 151.955H272.447L271.254 159.455H290.771L289.152 169H257.788ZM312.158 169H295.113L302.357 125.364H318.721C323.209 125.364 326.959 126.266 329.971 128.07C332.982 129.874 335.12 132.452 336.384 135.804C337.648 139.156 337.897 143.148 337.13 147.778C336.391 152.239 334.892 156.053 332.634 159.22C330.39 162.388 327.52 164.81 324.026 166.486C320.546 168.162 316.59 169 312.158 169ZM308.621 158.943H312.925C315.084 158.943 317.009 158.567 318.699 157.814C320.404 157.047 321.824 155.768 322.961 153.979C324.111 152.175 324.942 149.71 325.453 146.585C325.936 143.631 325.922 141.351 325.411 139.746C324.9 138.126 323.926 137.004 322.492 136.379C321.057 135.74 319.203 135.42 316.931 135.42H312.542L308.621 158.943Z" fill="#002B45"/>
              </svg>
            </>
          )}
        </h4>
      <nav className="nav flex-column">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
          >
            {link.label}
          </NavLink>
        ))}
        <button
          onClick={handleClientLogout}
          className="nav-link btn btn-link text-start"
          style={{ textDecoration: "none", fontWeight: "400" }}
        >
          Logout
        </button>
      </nav>
    </div>
    </>
  );
};

export default ClientSidebar;
